<template>
    <div id="Connexion" class="Connexion" data-view></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    data() {
        return {
            onLoading: false
        }
    },
    head: {
        title: {
            inner: "Connexion",
        }
    },
    computed: {
        ...mapState(['auth'])
    },
    methods: {
        ...mapActions([
            'setAuthFromApiAutoConnect',
            'setOnLoad'
        ]),
    },
    mounted() {
        this.setOnLoad(true)

        this.setAuthFromApiAutoConnect(
            this.$route.query
        ).then(() => {
            this.$cookies.set('token', this.auth.token)
            this.$api.postActivity({
                token: this.auth.token,
                category: 'connexion',
                action: 'auto-connexion',
                label: 'user autoconnect'
            });
            this.$router.push({ path: '/' })
        }).catch((error) => {
            this.setOnLoad(false)
            console.log(error)
        })
    }
}
</script>
